import styled from 'styled-components'

export const Page = styled.div`
  min-height: 100vh;
  padding: 32px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at top left, rgba(198, 1, 107, 0.12), transparent 32%),
    radial-gradient(circle at bottom right, rgba(3, 55, 92, 0.1), transparent 28%),
    linear-gradient(180deg, #f8fbff 0%, #eef4fa 100%);
`

export const Shell = styled.div`
  width: 100%;
  max-width: 980px;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const Hero = styled.div`
  background: linear-gradient(160deg, #071c2f 0%, #0f3b5f 52%, #c6016b 100%);
  color: #fff;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 24px 60px rgba(7, 28, 47, 0.24);
`

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 20px;
`

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(24px, 2.4vw, 32px);
  line-height: 1.2;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
`

export const Copy = styled.p`
  margin: 18px 0 0;
  font-size: 16px;
  line-height: 1.6;
  max-width: 46ch;
  color: rgba(255, 255, 255, 0.9);
`

export const Notes = styled.ul`
  margin: 28px 0 0;
  padding-left: 18px;
  display: grid;
  gap: 10px;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.5;
`

export const Card = styled.div`
  background: #fff;
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 22px 50px rgba(11, 28, 46, 0.12);
  border: 1px solid rgba(7, 28, 47, 0.08);
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #334155;
`

export const CheckRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: #334155;
  cursor: pointer;
`

export const CheckInput = styled.input`
  margin-top: 4px;
`

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`

export const ErrorBox = styled.div`
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff1f2;
  color: #9f1239;
  border: 1px solid #fecdd3;
`

export const SuccessBox = styled.div`
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
`
